module.exports = __webpack_public_path__ + "static/media/swipping_dai_body.b17e56cf.png";